import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PageSection from 'components/PageSection';
import WorkspaceContainer from 'containers/Workspaces/WorkspaceContainer';
import WorkspaceHome from './WorkspaceHome';
import WorkspaceTaskTests from './WorkspaceTaskTests';
import Overrides from './Overrides';
import { OrgContextLink, useOrgContext } from 'components/OrgContextProvider';

export default function WorkspaceRoot() {
	const ctx = useOrgContext();

	if (!ctx?.workspaceID) {
		return <div>Select a workspace from the selector above.</div>;
	}

	return !ctx?.tenantID || !ctx?.workspaceID ? <p>Select a tenant and workspace from the selector above.</p> : (
		<div key={`${ctx.tenantID}-${ctx.workspaceID}`}>
			<PageSection borderEnd={true}>
				<p className="appNav">
					<li><OrgContextLink to={`/`}>Workspace Home</OrgContextLink></li>
					<li><OrgContextLink to={`/overrides`}>Overrides</OrgContextLink></li>
					<li><OrgContextLink to={`/tasks`}>Tasks</OrgContextLink></li>
					<li><OrgContextLink to={`/manage`}>Manage</OrgContextLink></li>
					<li>Workspace '<span>{ctx.workspaceID}</span>'</li>
				</p>
			</PageSection>

			<Routes>
				<Route path="/" element={<WorkspaceHome />} />
				<Route path="/overrides/*" element={<Overrides />} />
				<Route path="/tasks" element={<WorkspaceTaskTests />} />
				<Route path="/manage" element={<WorkspaceContainer />} />
			</Routes>
		</div>
	);
}
